import axios from "axios";
import Cookies from "js-cookie";

export const API_URL = "https://api.taedil.com/"; 

//Set the logged in user data in local session
const setLoggedInUser = (user) => {
  Cookies.set("user", JSON.stringify(user));
  setPlantId(user.plant_details);
};

const getPlantId = () => {
  if (!Cookies.get("plant_details")) return null;
  return JSON.parse(Cookies.get("plant_details"));
};
const setPlantId = (plant_details) => {
  Cookies.set("plant_details", JSON.stringify(plant_details));
};
// Gets the logged in user data from local session
// const getLoggedInUser = () => {
//     const user = sessionStorage.getItem('user');
//     if (user) 5ED RT
//         return JSON.parse(user);
//     return null;
// }

const getLoggedInUser = () => {
  // if (!sessionStorage.getItem("user")) return null;
  // return JSON.parse(sessionStorage.getItem("user"));
  if (!Cookies.get("user")) return null;
  return JSON.parse(Cookies.get("user"));
};

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register Method
const postRegister = (url, data) => {
  return axios
    .post(url, data)
    .then((response) => {
      if (response.status >= 200 || response.status <= 299)
        return response.data;
      throw response.data;
    })
    .catch((err) => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};

// Login Method
const postLogin = (url, data) => {
  return axios
    .post(url, data)
    .then((response) => {
      if (response.status === 400 || response.status === 500)
        throw response.data;
      return response.data;
    })
    .catch((err) => {
      throw err[1];
    });
};

// postForgetPwd
const postForgetPwd = (url, data) => {
  return axios
    .post(url, data)
    .then((response) => {
      if (response.status === 400 || response.status === 500)
        throw response.data;
      return response.data;
    })
    .catch((err) => {
      throw err[1];
    });
};

let hayStackUrls = [];

const getPermissions = async () => {
  const user = await getLoggedInUser();
  if (user.id != 1) {
    await axios
      .get(`${API_URL}usergroup/findByCN/${user.user_group_common_name}`)
      .then((response) => {
        if (response.data.permission) {
          //generate array of page urls
          response.data.permission.forEach((item, i) => hayStackUrl(item));
        }
      });
  }
};

const hayStackUrl = (data) => {
  if (!data.hasOwnProperty("page_url") && data.children) {
    data.children.forEach(async (child, n) => await hayStackUrl(child));
  } else {
    hayStackUrls.push(data);
  }
};

const pageActions = async () => {
  const user = await getLoggedInUser();
  await getPermissions();
  let tempObj = {};
  await axios.get(`${API_URL}action`).then((response) => {
    response.data.forEach((item) => {
      tempObj[item.name] = true;
    });
  });

  if (user.id != 1) {
    let page = hayStackUrls.find(
      (item) => item.page_url === window.location.pathname
    );
    if (page) {
      page.children.forEach((child, i) => {
        tempObj[child.filename] = child.checked === "true";
      });
    }
  }
  return tempObj;
};

export {
  setLoggedInUser,
  getLoggedInUser,
  isUserAuthenticated,
  postRegister,
  postLogin,
  postForgetPwd,
  setPlantId,
  getPlantId,
  pageActions,
};
